export default function WhoCanParticipate() {
  const categories = [
    { icon: 'ri-bear-smile-line', title: 'Crianças', age: '03 a 12 anos', desc: 'Início promissor na carreira' },
    { icon: 'ri-user-smile-line', title: 'Adolescentes', age: '13 a 17 anos', desc: 'Fase ideal para começar' },
    { icon: 'ri-user-star-line', title: 'Jovens', age: '18 a 25 anos', desc: 'Auge para o mercado' },
    { icon: 'ri-user-heart-line', title: 'Adultos', age: '26 a 35 anos', desc: 'Maturidade e presença' },
    { icon: 'ri-camera-line', title: 'Influencers', age: 'Todas as idades', desc: 'Potencial digital' },
  ];

  return (
    <section id="quem-pode" className="py-14 sm:py-20 lg:py-28 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-10 sm:mb-14 lg:mb-16">
          <p className="text-xs font-bold text-yellow-600 tracking-widest uppercase mb-3">
            Aberto para todos
          </p>
          <h4 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-black mb-3">
            <a href="#quem-pode">
              Quem Pode <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">Participar</span>
            </a>
          </h4>
          <p className="text-sm sm:text-base lg:text-lg text-gray-600 max-w-xl mx-auto">
            Aberto para todos os perfis. Sem experiência necessária.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-5 lg:gap-6 mb-6 lg:mb-8">
          {categories.map((cat, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-4 sm:p-6 lg:p-8 shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-yellow-500 text-center group cursor-pointer">
              <div className="w-11 h-11 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${cat.icon} text-lg sm:text-2xl lg:text-3xl text-black`}></i>
              </div>
              <h3 className="text-sm sm:text-base lg:text-lg font-bold text-black mb-0.5 lg:mb-1">{cat.title}</h3>
              <p className="text-xs sm:text-sm lg:text-sm text-yellow-600 font-semibold mb-1">{cat.age}</p>
              <p className="text-xs lg:text-sm text-gray-500 hidden sm:block">{cat.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-black rounded-2xl p-4 sm:p-7 lg:p-8 text-center">
          <p className="text-sm sm:text-xl lg:text-2xl text-white font-bold">
            <span className="text-yellow-500">Zero experiência?</span> Sem problema. Avaliamos seu potencial natural.
          </p>
        </div>
      </div>
    </section>
  );
}